import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';

interface PROPS {
  cell: DTO__grid2d_cell;
  is_mouse_over: boolean;
}

export function GRID2D_CELL_BORDER__image_select({ cell, is_mouse_over }: PROPS) {
  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);

  const { g_grid2d__consume__hash_sha256_content, g_image_edit__select__image_asset, g_general__layout, g_image_edit__tab } = use_slice_ui([
    'g_grid2d__consume__hash_sha256_content',
    'g_image_edit__select__image_asset',
    'g_image_edit__tab',
    'g_general__layout',
  ]);

  /*
   * RENDERS
   */
  function render_border() {
    return <div className="absolute inset-0  size-full pointer-events-none  border-2 border-green-500 rounded-xl" />;
  }

  function render_layout_image_edit() {
    if (g_image_edit__tab != ENUM__page_generation_layout_images_edit_tab.SELECT) return null;
    if (is_mouse_over) return render_border();
    if (g_image_edit__select__image_asset.is_stub()) return null;
    if (cell.hash_sha256_content == g_image_edit__select__image_asset.hash_sha256_content) return render_border();

    return null;
  }

  function render_layout_output() {
    if (generation_current.graph_field_consumer.is_stub()) return null;
    if (is_mouse_over) return render_border();
    if (g_grid2d__consume__hash_sha256_content.is_empty_hash_sha256()) return null;
    if (cell.hash_sha256_content == g_grid2d__consume__hash_sha256_content) return render_border();

    return null;
  }

  function render_view() {
    if (g_general__layout == ENUM__page_generation_layout.ASSETS) return render_layout_image_edit();
    if (g_general__layout == ENUM__page_generation_layout.OUTPUTS) return render_layout_output();

    return null;
  }

  /*
   * HTML
   */

  if (cell.is_stub()) return null;

  return render_view();
}
